import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=10328698&scoped=true&"
var script = {}
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=10328698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10328698",
  null
  
)

export default component.exports